/**
 * Delay API
 *
 * API endpoints for delay management operations
 */

import toast from "react-hot-toast";

import { nextCargoApi } from "../../baseApi";

/**
 * Delay API endpoints
 * Provides operations for delay management
 */
export const delayApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Delete a delay
     * @param id - Delay ID
     * @returns void
     */
    deleteDelay: build.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `/delay/delete/${id}`,
        method: "DELETE"
      }),
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Deletando atraso...",
          success: "Atraso deletado com sucesso!",
          error: "Erro ao deletar atraso."
        });
      }
    })
  })
});

/**
 * Enhance endpoints with cache tag configuration
 */
delayApi.enhanceEndpoints({
  addTagTypes: ["Delay"],
  endpoints: {
    deleteDelay: {
      invalidatesTags: ["SettingsByCompany", { type: "Delay", id: "LIST" }]
    }
  }
});
